import { initializeApp } from "firebase/app";
import { getStorage} from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyCydSgPLSaHn2FnqjBBEXz-CYNuhGHDzfw",
  authDomain: "chatmedia786.firebaseapp.com",
  projectId: "chatmedia786",
  storageBucket: "chatmedia786.appspot.com",
  messagingSenderId: "982442102270",
  appId: "1:982442102270:web:10f10383c7138ae355c4af",
  measurementId: "G-N0Q8JFYFVE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);